import { PRELOAD_DATA } from '../../../car/dataPreload/store/preload.action-types';
import { RESET_STATE } from '../../../wizard/store/wizard.action-types';
import { NAME_SAVE } from './name.action-types';

const INITIAL_STATE = {
  selected: {
    name: null,
    surname: null,
    isCompany: false,
  },
};

const nameV2Reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case PRELOAD_DATA: {
      return reduceWithName(action.payload.person.name, state);
    }
    case RESET_STATE:
      return {
        ...state,
        selected: {
          name: null,
          surname: null,
          isCompany: false,
        },
      };
    case NAME_SAVE:
      return reduceWithName(action.payload, state);
    default:
      return state;
  }
};

const reduceWithName = (name, state) => {
  return { ...state, selected: name };
};

export default nameV2Reducer;